const featuredEdits = [
  {
    title: "AoG | If I Lose Myself",
    image: "/assets/film/AoG.jpg",
    url: "https://drive.google.com/file/d/15y_5nZE-6RDYerH_Lnja-lOqsq_m0h3r/preview",
  },
  {
    title: "Scream VI | Here",
    image: "/assets/film/Here.jpg",
    url: "https://www.youtube.com/embed/HkgYZgsi7vo?si=Pqh9k8fpRBGTOEKV",
  },
  {
    title: "Josie Saltzman | thank u, next",
    image: "/assets/film/thank u next.jpg",
    url: "https://www.youtube.com/embed/gotlBkPmHXg?si=bcxtzHYpXNeZrU9v",
  },
  {
    title: "Stranger Things | Con Calma",
    image: "/assets/film/Con Calma.jpg",
    url: "https://www.youtube.com/embed/yusYeHSawQE?si=fSvoG0HIQQ0FZHRR",
  },
  {
    title: "Escape Room | This Love",
    image: "/assets/film/This Love.jpg",
    url: "https://www.youtube.com/embed/xY7ROHEOw80?si=VNQEgq2ruK_3ne6V",
  },
  {
    title: "Sam Carpenter & Kirby Reed | The Exit",
    image: "/assets/film/The Exit.jpg",
    url: "https://www.youtube.com/embed/mcoEWgPOjhA?si=uaQimaColmcAA6jF",
  },
  {
    title: "Olivia Rodrigo | Backstabber",
    image: "/assets/film/Backstabber.jpg",
    url: "https://www.youtube.com/embed/ifw0XAlJBbQ?si=CoWmwWs7KxmEbbki",
  }
];

export default featuredEdits;
